import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import logo from '../../Assets/Images/logo.png';
import { COMPANY, CONTACT, SOCIAL_LINKS } from '../../utils/constants';
import GradientText from '../common/GradientText';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];


  const legalLinks = [
    { name: 'Privacy Policy', path: '/PrivacyPolicy' },
    { name: 'Terms & Conditions', path: '/TermsAndConditions' },
    { name: 'Cancellation Policy', path: '/cancellationPolicy' },
    { name: 'Cookie Policy', path: '/CookiePolicy' },
  ];

  const socialIcons = [
    { Icon: FaInstagram, link: SOCIAL_LINKS.instagram },
  ];

  return (
    <footer className="bg-dark-bg text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img src={logo} alt={COMPANY.name} className="h-12 w-auto mb-4" />
            <p className="text-gray-300 mb-4">
              <GradientText className="block mb-2">{COMPANY.tagline}</GradientText>
              {COMPANY.description}
            </p>
            <div className="flex space-x-4">
              {socialIcons.map(({ Icon, link }, index) => (
                <a
                  key={index}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-800 hover:bg-gradient-primary flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <Icon className="text-lg" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-white hover:translate-x-1 inline-block transition-all duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaPhone className="text-primary-blue mt-1 mr-3" />
                <a href={`tel:${CONTACT.phone}`} className="text-gray-300 hover:text-white transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-start">
                <FaEnvelope className="text-primary-blue mt-1 mr-3" />
                <a href={`mailto:${CONTACT.email}`} className="text-gray-300 hover:text-white transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-primary-blue mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-300">
                  {CONTACT.address}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {COMPANY.name}. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              {legalLinks.map((link, index) => (
                <React.Fragment key={link.name}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                  {index < legalLinks.length - 1 && <span className="text-gray-600">|</span>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
